
        import 'WelcomeHeader.1018d57.css-module'
        export default {"header":"header_WelcomeHeader_1018d57"}
    